import { Component, OnInit } from "@angular/core";
import { CapabilityService } from "../../../../auth/service/capability.service";
import { locale as italian } from "../../../../i18n/it";
import { UtilsService } from "../../../../auth/service/utils.service";
import { AuthenticationService } from "../../../../auth/service";
import { IContentHeader } from "app/layout/components/content-header/content-header.component";

@Component({
  selector: "app-capability-list",
  templateUrl: "./capability-list.component.html",
  styleUrls: ["./capability-list.component.scss"],
})
export class CapabilityListComponent implements OnInit {
  public contentHeader: IContentHeader;
  public tableLimit: number = 10;
  private capabilities: any;
  public filteredCapabilities: any;
  public searchKeyword: string = "";

  constructor(
    public _capabilityService: CapabilityService,
    private _utilsService: UtilsService,
    public _authenticationService: AuthenticationService,
  ) {}

  async ngOnInit() {
    this.contentHeader = {
      headerTitle: italian.data.TITLES.CAPABILITY_USERS,
      actionButton: false,
      breadcrumb: {
        type: "",
        links: [
          {
            name: "Home",
            isLink: true,
            link: "/",
          },
          {
            name: italian.data.MENU.MANAGE,
            isLink: true,
            link: "/dashboard/platform-management",
          },
          {
            name: italian.data.TITLES.CAPABILITY_USERS,
            isLink: false,
          },
        ],
      },
    };

    await this.loadCapabilities();
  }

  async loadCapabilities() {
    this.capabilities = await this._capabilityService.getList().then((result: any) => {
      return result.sort((a: any, b: any) => {
        a = Number(a.id);
        b = Number(b.id);
        return a > b ? -1 : a < b ? 1 : 0;
      });
    });
    this.doFilter();
  }

  doFilter() {
    let filtered: any = this.capabilities;

    if (this.searchKeyword.length > 0) {
      const keyword: string = this.searchKeyword.toLowerCase();
      filtered = filtered.filter((cap: any) => cap.name.toLowerCase().includes(keyword) || cap.code.toLowerCase().includes(keyword));
    }

    this.filteredCapabilities = filtered;
  }

  async remove(event: any, capability_id: number) {
    event.preventDefault();
    await this._utilsService
      .showSWAL({
        title: "CONFIRM_DELETE_TITLE",
        text: "CONFIRM_DELETE_TEXT",
        icon: "warning",
        confirmButtonText: "CONFIRM_DELETE_BTN",
        customClass: {
          confirmButton: "btn btn-danger",
        },
      })
      .then(async (result: any) => {
        if (result.value) {
          if (!this._authenticationService.hasCapability("remove_capability")) {
            window.history.back();
            return false;
          }
          await this._capabilityService.delete(capability_id).then(async () => {
            await this._utilsService.showPopupItemDeleted().then(async () => {
              await this.loadCapabilities();
            });
          });
        } else if (result.isDismissed) {
          await this._utilsService.showSWAL({
            title: "ABORTED_TITLE",
            text: "ABORTED_TEXT",
            icon: "error",
            confirmButtonText: "BTN_CLOSE",
            showCancelButton: false,
            customClass: {
              confirmButton: "btn btn-success",
            },
          });
        }
      });
  }
}
